import React, { createContext, useContext, useState } from 'react';

const ReportingContext = createContext();

export const useReporting = () => {
  const context = useContext(ReportingContext);
  if (!context) {
    throw new Error('useReporting must be used within a ReportingProvider');
  }
  return context;
};

export const ReportingProvider = ({ children }) => {
  const [isReporting, setIsReporting] = useState(false);

  const value = {
    isReporting,
    setIsReporting,
  };

  return (
    <ReportingContext.Provider value={value}>
      {children}
    </ReportingContext.Provider>
  );
};

export default ReportingContext; 